import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  container: {
    background: '#FAFAFA',
    borderRadius: 5,
    width: '100%',
    height: '100%',
    minHeight: '692px',
  },
  containerPaper: {
    '& .MuiDialog-paper': {
      padding: '10px',
      maxWidth: 'none',
      borderRadius: 20,
      width: '880px',
      '@media only screen and (max-width: 600px)': {
        padding: '0px !important',
      },
    },
  },
  btn: {
    display: 'block',
    margin: 'auto',
    marginBottom: 10,
    background: '#000A8C',
    marginTop: 20,
  },
  flexContent: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  icon: {
    width: 14,
    height: 14,
  },
  btnClose: {
    background: '#E63C3C',
    position: 'absolute',
    top: 0,
    right: 0,
  },

  formInput: {
    width: '100%',
    '& div fieldset': {
      borderColor: '#E4E4F2',
      top: '-6px',
    },
    '& div input': {
      paddingTop: 12,
      paddingBottom: 12,
      fontSize: 14,
    },
  },
  checkedIcon: {
    backgroundColor: 'transparent',
    borderRadius: 5,
    border: '1px solid #000A8C',
    padding: 2,
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      content: '""',
      backgroundColor: '#000A8C',
      borderRadius: 4,
    },
  },
  iconC: {
    borderRadius: 5,
    width: 16,
    height: 16,
    backgroundColor: 'white',
    border: '1px solid #000A8C',
    padding: 2,
    '$root.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
  },
}));
